import React from 'react';
import classNames from 'classnames';

export default class GridRow extends React.Component {
  constructor() {
    super();
  }

  render() {
    const { children, className } = this.props;
    let rowClasses = classNames('grid', className);
    return (
      <section className={rowClasses}>
        {children}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/client/components/grid/grid-row.jsx